import { JwtAuthenticatedApiClient } from '@guiker/booking-shared'
import { useJwtAuthenticatedApiClient } from '@guiker/react-framework'

export const useJwtBookingApiClient = useJwtAuthenticatedApiClient(JwtAuthenticatedApiClient)
